<template>
  <div style="display: flex; flex-direction: column">
    <el-checkbox
      v-model="job.dischargingPortDoor"
      no="dischargingPortDoor"
      :title="$t('SeaExport.DispatchVehiclesAtDestination')"
      @change="onChange('dischargingPortDoor')"
    >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
    </el-checkbox>
    <el-checkbox
      v-model="job.usCustomsClearance"
      no="usCustomsClearance"
      :title="$t('queryJob.UsCustomsClearance')"
      @change="onChange('usCustomsClearance')"
    >{{ $t('queryJob.UsCustomsClearance') }}
    </el-checkbox>
    <el-checkbox
      v-model="job.destPortCustomsClearance"
      no="destPortCustomsClearance"
      :title="$t('SeaExport.PortOfDestinationCustomsClearance')"
      @change="onChange('destPortCustomsClearance')"
    >{{ $t('SeaExport.PortOfDestinationCustomsClearance') }}
    </el-checkbox>
  </div>
</template>

<script>
export default {
  name: 'AeBasicPortOfDestinationServices',
  props: {
    job: { type: Object, default: () => { return {} } }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    }
  }
}
</script>
